import axios from 'axios';

import { responseInterceptor, errorInterceptor } from './interceptors';
import { Environment } from '../../../environment';

const tokenFromLocalStorage = localStorage.getItem('APP_ACCESS_TOKEN');
const parsedToken = (() => {
  if (!tokenFromLocalStorage) return undefined;
  try {
    return JSON.parse(tokenFromLocalStorage);
  } catch {
    return tokenFromLocalStorage;
  }
})();
const authorizationHeader = parsedToken ? `Bearer ${parsedToken}` : '';

const Api = axios.create({
  baseURL: Environment.URL_BASE,
  timeout: 20000,
  headers: {
    Authorization: authorizationHeader
  }
});

Api.interceptors.response.use(
  (response) => responseInterceptor(response),
  (error) => errorInterceptor(error),
);

const ApiLogin = axios.create({
  baseURL: Environment.URL_BASE_LOGIN,
  timeout: 20000,
  headers: {
    Authorization: authorizationHeader
  }
});

ApiLogin.interceptors.response.use(
  (response) => responseInterceptor(response),
  (error) => errorInterceptor(error, false),
);

export {Api, ApiLogin};